import React from 'react';

import { Form, Modal, Rate } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'segments/hooks';
import { useNotification } from 'segments/hooks/useNotification';

import { InputStr, SubmiteButton } from 'shared/FormItems';
import { ModalFooter } from 'shared/Modals';

import { selectActiveCoach, UpdateCoachParams, useUpdateCoachMutation } from 'features/coaches';
import { SelectImage } from 'features/imagesStore';
import { SelectTimePrice } from 'features/timesPrice';

type FormData = UpdateCoachParams;

interface Props {
  handleCancel: () => void;
}
export const EditCoachModal = ({ handleCancel }: Props) => {
  const { t } = useTranslation();
  const data = useAppSelector(selectActiveCoach);
  const [update, { isSuccess, isError, isLoading, error }] = useUpdateCoachMutation();
  const [form] = Form.useForm<FormData>();

  useNotification({
    isSuccess,
    isError,
    error,
    onSuccess: () => {
      handleCancel();
      form.resetFields();
    },
    onError: () => {
      handleCancel();
      form.resetFields();
    },
  });

  if (data === null) {
    return;
  }

  const onFinish = (values: FormData) => {
    const vs = Object.fromEntries(Object.entries(values).filter(([_, v]) => v != null));
    update({ ...vs, id: data?.id } as FormData);
  };

  return (
    <Modal
      title={t('coaches.title.edit')}
      open
      onCancel={handleCancel}
      destroyOnClose
      footer={[
        <ModalFooter
          key="modalFooter"
          handleCancel={handleCancel}
          resetFields={form.resetFields}
        />
      ]}
    >
      <Form
        name="basic"
        layout="vertical"
        form={form}
        initialValues={{ ...data }}
        onFinish={onFinish}
        autoComplete="off"
        className="edit-user__form"
      >
        <InputStr type="name" />
        <InputStr type="metainfo.description" />
        <SelectImage />
        <Form.Item name={['metainfo', 'rating']} label={t('form-items.input.metainfo.rating')}>
          <Rate allowHalf />
        </Form.Item>
        <SelectTimePrice<FormData> formProps={{ form, initialValue: data.metainfo.pricing }} />
        <SubmiteButton submiteText={t('user.edit-data')} isLoading={isLoading} />
      </Form>
    </Modal>
  );
};

